export class Login {
  username: string;
  password: string;

  constructor(username?: string, password?: string) {
    this.username = username;
    this.password = password;
  }

  toSign() {
    return this.username + this.password
  }

  public toJson() {
    return {
      username: this.username,
      password: this.password
    };
  }
}
